import { BookOpen, Search } from "lucide-react";
import { Button } from "components/ui/button";
import { CourseCard } from "components/learner/CourseCard";
import { AssignedCourseSummary, CourseProgressData } from "types";
import { learnerCourseState } from "utils/learnerCourses";

const filters = [
  { value: "all", label: "All" },
  { value: "in_progress", label: "In progress" },
  { value: "not_started", label: "Not started" },
  { value: "completed", label: "Completed" },
];
export function CourseLibrary({ courses, progress, search, filter, onSearch, onFilter, onStart, onRetry, courseErrors = {} }: {
  courses: AssignedCourseSummary[];
  progress: Record<number, CourseProgressData>;
  search: string;
  filter: string;
  onSearch: (value: string) => void;
  onFilter: (value: string) => void;
  onStart: (summary: AssignedCourseSummary) => void;
  onRetry: () => void;
  courseErrors?: Record<number, unknown>;
}) {
  const visible = [...courses].sort((a, b) => a.order - b.order).filter((course) => {
    const state = courseErrors[course.id] ? "unavailable" : learnerCourseState(course, progress[course.id]);
    const text = `${course.name} ${progress[course.id]?.course?.description || course.description || ""}`.toLocaleLowerCase();
    return text.includes(search.trim().toLocaleLowerCase()) && (filter === "all" || state === filter);
  });
  return <div className="course-library" id="courses">
    {courses.length > 0 && <div className="course-library-tools">
      <label className="course-search"><Search size={18} aria-hidden="true" /><input aria-label="Search courses" placeholder="Find a course…" value={search} onChange={(event) => onSearch(event.target.value)} /></label>
      <div className="course-filters" aria-label="Filter courses">{filters.map((item) => <button key={item.value} type="button" aria-pressed={filter === item.value} onClick={() => onFilter(item.value)}>{item.label}</button>)}</div>
    </div>}
    {courses.length === 0 ? <div className="course-empty"><BookOpen size={36} aria-hidden="true" /><h2>Your next chapter starts here</h2><p>When a course is assigned to you, it will appear here. Ask your organization administrator or mentor to help you get started.</p></div>
    : visible.length === 0 ? <div className="course-empty" role="status"><Search size={30} aria-hidden="true" /><h2>No matching courses</h2><p>Try a different search or view all your courses.</p><Button size="auto" variant="secondary" onClick={() => { onSearch(""); onFilter("all"); }}>Clear filters</Button></div>
    : <div className="course-card-grid">{visible.map((summary) => <CourseCard key={summary.id} summary={summary} progress={progress[summary.id]} unavailable={Boolean(courseErrors[summary.id])} onStart={onStart} onRetry={onRetry} />)}</div>}
  </div>;
}
